// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__F-Jsd","loading":"Loading_loading__wrJW-"};